<template>
  <v-card>
    <v-card-text>
      <h3>Data transfer</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'bit / second (bit/s)',
          val: 1
        },
        {
          text: 'byte / second (B/s)',
          val: 0.125
        },
        {
          text: 'kilobit / second (Kbit/s)',
          val: 0.0009765625
        },
        {
          text: 'kilobyte / second (KB/s)',
          val: 0.0001220703125
        },
        {
          text: 'megabit / second (Mbit/s)',
          val: 9.536743164063e-7
        },
        {
          text: 'megabyte / second (MB/s)',
          val: 1.192092895508e-7
        },
        {
          text: 'gigabit / second (Gbit/s)',
          val: 9.313225746155e-10
        },
        {
          text: 'gigabyte / second (GB/s)',
          val: 1.164153218269e-10
        },
        {
          text: 'byte / minute (B/min)',
          val: 7.5
        },
        {
          text: 'byte / hour (B/h)',
          val: 450
        },
        {
          text: 'kilobyte / minute (KB/min)',
          val: 0.00732421875
        },
        {
          text: 'kilobyte / hour (KB/h)',
          val: 0.439453125
        },
        {
          text: 'megabyte / minute (MB/min)',
          val: 0.000007152557373047
        },
        {
          text: 'megabyte / hour (MB/h)',
          val: 0.0004291534423828
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// data-transfer.vue?717a630f